// PATH SIMPLIFICATION ALGORITHM
// Douglas Peucker path simplification algorithm
// This code is based on https://gist.github.com/adammiller/826148
const Line = (function () {
  const Constructor = function Line(p1, p2) {
    this.p1 = p1;
    this.p2 = p2;
  };

  Constructor.prototype.distanceToPoint = function (point) {
    // slope
    const m = (this.p2[0] - this.p1[0]) / (this.p2[1] - this.p1[1]);
    // y offset
    const b = this.p1[0] - (m * this.p1[1]);
    const d = [];

    /* eslint-disable */
    // distance to the linear equation
    d.push(Math.abs(point[0] - (m * point[1]) - b) / Math.sqrt(Math.pow(m, 2) + 1));
    // distance to p1
    d.push(Math.sqrt(Math.pow((point[1] - this.p1[1]), 2) + Math.pow((point[0] - this.p1[0]), 2)));
    // distance to p2
    d.push(Math.sqrt(Math.pow((point[1] - this.p2[1]), 2) + Math.pow((point[0] - this.p2[0]), 2)));
    /* eslint-enable */

    // return the smallest distance
    // causes an array to be sorted numerically and ascending
    return d.sort((a, b) => (a - b))[0];
  };

  return Constructor;
}());

function douglasPeucker(points, tolerance) {
  if (points.length <= 2) {
    return [points[0]];
  }

  let returnPoints = [];
  // make line from start to end
  const line = new Line(points[0], points[points.length - 1]);
  // find the largest distance from intermediate poitns to this line
  let maxDistance = 0;
  let maxDistanceIndex = 0;
  let p;

  for (let i = 1; i <= points.length - 2; i++) {
    const distance = line.distanceToPoint(points[i]);
    if (distance > maxDistance) {
      maxDistance = distance;
      maxDistanceIndex = i;
    }
  }

  // check if the max distance is greater than our tollerance allows
  if (maxDistance >= tolerance) {
    p = points[maxDistanceIndex];
    line.distanceToPoint(p, true);
    // include this point in the output
    returnPoints = returnPoints.concat(
      douglasPeucker(points.slice(0, maxDistanceIndex + 1), tolerance),
    );
    // returnPoints.push( points[maxDistanceIndex] );
    returnPoints = returnPoints.concat(
      douglasPeucker(points.slice(maxDistanceIndex, points.length), tolerance),
    );
  } else {
    // ditching this point
    p = points[maxDistanceIndex];
    line.distanceToPoint(p, true);
    returnPoints = [points[0]];
  }

  return returnPoints;
}

// These two functions allow you to express the epsilon factor
// (max distance to perpendicular line segment of point to remove)
// in metres.
// About this value see
// https://en.wikipedia.org/wiki/Ramer%E2%80%93Douglas%E2%80%93Peucker_algorithm
// this is approximate (spherical earth, average circumference, not considering
// altitude, etc.)
export function degreesToMeters(degrees) {
  // average circumference in metres at sea level
  return degrees * 40075000 / 360.0;
}

// this is approximate (spherical earth, average circumference, not considering
// altitude, etc.)
export function metersToDegrees(meters) {
  // average circumference in metres at sea level
  return meters * 360.0 / 40075000;
}

// eslint-disable-next-line
export const simplify = function(points, tolerance) {
  // always have to push the very last point on so it doesn't get left off
  return [].concat(douglasPeucker(points, tolerance), points.slice(-1));
};
